var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 32.2 42.1",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 853 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0996 20C21.6225 20 26.0996 15.5228 26.0996 10C26.0996 4.47715 21.6225 0 16.0996 0C10.5768 0 6.09961 4.47715 6.09961 10C6.09961 15.5228 10.5768 20 16.0996 20ZM16.0996 17.7881C11.7984 17.7881 8.31154 14.3012 8.31154 10C8.31154 5.69877 11.7984 2.21193 16.0996 2.21193C20.4008 2.21193 23.8877 5.69877 23.8877 10C23.8877 14.3012 20.4008 17.7881 16.0996 17.7881Z",
    fill: "var(--fill-0, #9AB3C2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 1403 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 35C0 38.9212 3.17878 42.1 7.1 42.1H25.1C29.0212 42.1 32.2 38.9212 32.2 35V34C32.2 27.8696 27.2304 22.9 21.1 22.9H11.1C4.96964 22.9 0 27.8696 0 34V35ZM7.1 39.9C4.3938 39.9 2.2 37.7062 2.2 35V34C2.2 29.0847 6.18467 25.1 11.1 25.1H21.1C26.0153 25.1 30 29.0847 30 34V35C30 37.7062 27.8062 39.9 25.1 39.9H7.1Z",
    fill: "var(--fill-0, #9AB3C2)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.9321c3aec12b66d12e80a2c1a2297d21.svg";
export { ForwardRef as ReactComponent };